<template>
  <div class="chart-container" @click="open = false">
    <a-icon
      class="chart-close"
      type="close"
      @click="$emit('closeChart', false)"
    />
    <slot name="extra"></slot>
    <div class="chart-norm-select">
      标准值：<a-select
        style="width: 90px"
        size="small"
        :open="open"
        v-model="waterNorm"
        @mouseenter="open = true"
        :maxTagCount="0"
        mode="multiple"
      >
        <a-select-option
          v-for="item in waterNormOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>
    <highcharts :options="options" ref="chart" class="chart"></highcharts>
  </div>
</template>

<script>
import { patrol_chart_options } from "@/options/chart";
import { isCheckNumber } from "@/utils/utils";
import { waterValueV, waterNormOptions } from "@/options/common";
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      options: patrol_chart_options,
      waterNormOptions,
      waterNorm: [],
      open: false
    };
  },
  props: {
    sensortype: {
      type: String,
      default: ""
    },
    trackDataInfo: {
      type: Object,
      default: () => {}
    },
    tableCurrRow: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    sensortype() {
      this.drawChart();
    },
    trackDataInfo() {
      this.drawChart();
    },
    tableCurrRow() {
      this.drawChart();
    },
    waterNorm() {
      this.drawChart();
    }
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart: _.debounce(function() {
      let columns = this.trackDataInfo.columns;
      let data = this.trackDataInfo.data;
      let station = this.trackDataInfo.station;
      this.options.series = [];
      this.options.annotations = [];
      this.options.yAxis.plotLines = [];
      if (this.tableCurrRow.end_time) {
        this.options.title.text =
          moment(this.tableCurrRow.start_time).format("HH:mm") +
          "至" +
          moment(this.tableCurrRow.end_time).format("HH:mm") +
          this.tableCurrRow.name;
      } else {
        this.options.title.text = this.tableCurrRow.name + "(进行中)";
      }

      //   this.options.yAxis.title.text =
      //     sensorTypeInfo.label + "(" + sensorTypeInfo.unit + ")";
      if (_.isEmpty(this.trackDataInfo)) {
        return;
      }
      const valueVInfo = waterValueV.find(x => x.value == this.sensortype);
      const sIndex = columns.indexOf(this.sensortype);
      let sensorTypeInfo = G_SENSOR_DATA_TYPE_INFO.find(
        a => a.value === this.sensortype
      );
      let series = {
        name: sensorTypeInfo.label,
        data: _(data)
          .filter(x => isCheckNumber(x[sIndex]))
          .map(x => [x[0] * 1000, Number(x[sIndex])])
          .value(),
        data_type: this.sensortype,
        marker: { radius: 1, symbol: "square", enabled: true },
        animation: false,
        is_water_V: false
      };
      this.options.series.push(series);

      if (valueVInfo) {
        const timeList = _.map(data, x => x[0] * 1000);
        if (valueVInfo.value !== "ph") {
          if (this.waterNorm.length > 0) {
            this.waterNorm.forEach(w => {
              let series = {
                name: `${w}类水质标准`,
                data: timeList.map(x => [x, valueVInfo["value_" + w]]),
                dashStyle: "dash",
                clip: false, // 解决峰值线溢出不展示问题
                lineWidth: 2,
                color: "red",
                zIndex: 2,
                marker: { radius: 0, enabled: true },
                animation: false,
                data_type: this.sensortype,
                is_water_V: true // 是否V类水质标准
              };
              this.options.series.push(series);
              this.options.annotations.push({
                labels: [
                  {
                    point: {
                      x: timeList[timeList.length - 1],
                      y: valueVInfo["value_" + w],
                      xAxis: 0,
                      yAxis: 0
                    },
                    text: sensorTypeInfo.label + `${w}类水质标准`,
                    // style: {
                    //   fontSize: "14px"
                    // },
                    shape: "rect",
                    padding: 0,
                    y: 0,
                    x: 50
                  }
                ],
                labelOptions: {
                  backgroundColor: "#fff",
                  borderWidth: 0,
                  borderColor: "#fff",
                  style: {
                    fontSize: "14px"
                  }
                },
                draggable: "xy",
                zIndex: 1
              });
            });
          }
        } else {
          let plotLines = [];
          valueVInfo.value_V.forEach(v => {
            plotLines.push({
              width: 3,
              value: v,
              dashStyle: "dash",
              color: "red",
              zIndex: 2,
              label: {
                text: sensorTypeInfo.label + " " + v,
                align: "right",
                x: -60,
                y: -10,
                style: {
                  fontSize: "14px"
                }
              }
            });
            this.options.yAxis.plotLines = plotLines;
          });
        }
      }
    }, 300)
  }
};
</script>

<style lang="less" scoped>
.chart-container {
  position: absolute;
  bottom: 72px;
  right: 144px;
  z-index: 100;
}
.chart-close {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 100;
}
.chart-norm-select {
  position: absolute;
  right: 5px;
  top: 24px;
  z-index: 100;
}
.chart {
  width: 640px;
  height: 300px;
}
</style>
